export default __webpack_public_path__ + "1f6f40bcfd8780bd500c865eb5cdada7.png";